import { useSelector } from 'react-redux';
import { ApplicationState } from '../rootStore';

export const useIntegrationTypeReducer = () =>
  useSelector((state: ApplicationState) => state.integration);
